import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import countries_sectionone1 from './Assets/countries/countries_sectionone1.png';
import configData from './Config.json';
import Metatags from './Metatags.js';

import landingpage_facebookicon from './Assets/landingpage_facebookicon.png';
import landingpage_linkedinicon from './Assets/landingpage_linkedinicon.png';
import landingpage_instagramicon from './Assets/landingpage_instagramicon.png';
import landingpage_emailicon from './Assets/landingpage_emailicon.png';
import landingpage_whatsappicon from './Assets/landingpage_whatsappicon.png';
import landingpage_appstore from './Assets/appstore.png';
import landingpage_playstore from './Assets/playstore.png';

import './LandingPage.css';

function LandingPage({ state, setState }) {

    const history = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleCountry = (country) => {
        setState(state => ({
            ...state,
            selectedcountry: country.id,
            selecteddistrict: country.defaultdistrict,
            selectedcommunity: 0,
            selectedoffset: 0,
            selectedagreement: 0,
            selectedtype: 0
        }))
        history('/' + country.dir)
    }

    const handleWhatsapp = (text) => {
        const phoneNumber = "+96170617919";
        const encodedText = encodeURIComponent(text);
        const url = `https://wa.me/${phoneNumber}?text=${encodedText}`;

        window.open(url, "_blank", "noopener,noreferrer");
    }

    return (
        <div className='countries'>
            <Metatags
                title='SoukAkarat.com | Online real estate listings'
                description="SoukAkarat.com has listings for properties. Place a free ad. Find what you're looking for now!"
                keywords='buy, sell, rent, properties, arab countries, شراء, بيع, إيجار, عقارات, البلاد العربية'
                canonical={configData.SECUREURL}
                robots='index'
                image={configData.SECUREURL + '/' + configData.SEOIMAGE}
            />
            <div className='countries_section2'>
                <img
                    className='countries_section2logo'
                    src={countries_sectionone1}
                    alt='sectionone1'
                    loading='lazy'
                    height='1000'
                    width='1000'
                />
                <div className='countries_section2title'>
                    <h1 className='countries_section2title1'>Search Properties for Sale & Rent</h1>
                    <h1 className='countries_section2title2'>Electronic Real Estate platform in the Arab World</h1>
                </div>
            </div>
            <div className='countries_section3'>
                <div className='countries_section3countrycontainer'>
                    {
                        state.countries.map((country, index) =>
                            <div key={'country' + index} className='countries_section3countryitem' onClick={() => handleCountry(country)} >
                                <h3 className='countries_section3countryitemtext'>{country.name} ({country.count})</h3>
                            </div>
                        )
                    }
                </div>
            </div>
            <div className='countries_section4'>
                <h4 className='countries_section4title'>Online real estate listings network</h4>
                <p className='countries_section4text'>SoukAkarat is a comprehensive online real estate listings network that simplifies the process of finding a property. Our platform allows users to browse and search for properties with ease, making it easier than ever to find the perfect home or investment opportunity. What sets us apart is that we offer these services completely online and at no cost to our users. Whether you're a buyer, seller, or landlord, SoukAkarat has the resources you need to navigate the real estate market with confidence. <span className='countries_sectiontwohashtags'>#realEstate</span>  <span className='countries_sectiontwohashtags'>#listings</span>  <span className='countries_sectiontwohashtags'>#properties</span></p>
            </div>
            <div className='countries_section5'>
                <h4 className='countries_section5title'>Disclaimer</h4>
                <p className='countries_section5text'>It is important for users to exercise due diligence and verify the authenticity of any property they are interested in. This may include conducting thorough inspections, obtaining professional advice, and verifying ownership and legal documentation.</p>
                <p className='countries_section5textarabic'>يجب على المستخدمين ممارسة العناية الواجبة والتحقق من صحة أي عقار يهتمون به. وقد يشمل ذلك إجراء عملية تدقيق والتحقق من الملكية والوثائق القانونية.</p>
            </div>

            <footer className="homepage_footer">
                <div className="homepage_footercontainer">
                    <div className="homepage_footerbrand">
                        <p className="homepage_footername">SOUK AKARAT</p>
                        <p className="homepage_footertagline">ONLINE REAL ESTATE LISTINGS</p>
                    </div>

                    <div className="homepage_socialicons">
                        <a className="homepage_footersocialiconcontainer" href={configData.FACEBOOKLINK} target="_blank" rel="noopener noreferrer" title="Facebook">
                            <img className='homepage_footersocialicon' src={landingpage_facebookicon} alt="Facebook Icon" />
                        </a>
                        <a className="homepage_footersocialiconcontainer" href={configData.LINKEDINLINK} target="_blank" rel="noopener noreferrer" title="LinkedIn">
                            <img className='homepage_footersocialicon' src={landingpage_linkedinicon} alt="LinkedIn Icon" />
                        </a>
                        <a className="homepage_footersocialiconcontainer" href={configData.INSTAGRAMLINK} target="_blank" rel="noopener noreferrer" title="Instagram">
                            <img className='homepage_footersocialicon' src={landingpage_instagramicon} alt="Instagram Icon" />
                        </a>
                        <a className="homepage_footersocialiconcontainer" href={configData.EMAILLINK} title="Email">
                            <img className='homepage_footersocialicon' src={landingpage_emailicon} alt="Email Icon" />
                        </a>
                        <a className="homepage_footersocialiconcontainer" onClick={() => handleWhatsapp('')} target="_blank" rel="noopener noreferrer" title="WhatsApp">
                            <img className='homepage_footersocialicon' src={landingpage_whatsappicon} alt="Whatsapp Icon" />
                        </a>
                    </div>

                    <div className='countries_footerLinkContainer'>
                        <Link className='countries_footerLink' to='privacypolicy'>Privacy Policy</Link>
                    </div>
                    <p className="homepage_footercopyright">© 2026 PROPERTY DYNAMICS. ALL RIGHTS RESERVED.</p>
                </div>
            </footer>
        </div>
    )
}

export default LandingPage;